import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'normSelector'
})
export class NormalizeSelectorPipe implements PipeTransform {
  constructor() {}

  transform(value: string): unknown {
    return value.replace(/ /g, '-').replace(/&/g, '-').toLocaleLowerCase();
  }
}
